import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import toast, { Toaster } from 'react-hot-toast';
import { MdClear } from "react-icons/md";
import './NuevaCama.css';
import Select from 'react-select'
import * as Constants from '../../constants';
import CamaService from '../../services/cama.service';
import HabitacionService from '../../services/habitacion.service';


const PopUpCama = (props) => {

	const [listaHabitaciones, setListaHabitaciones] = useState([]);
	const [selectedHabitacion, setSelectedHabitacion] = useState('');
	const [selectedCama, setSelectedCama] = useState(null);
	const [listaTiposCama, setListaTiposCama] = useState([])
	const [selectedTipoCama, setSelectedTipoCama] = useState(null);

	const [habitacion, setHabitacion] = useState('')
	const [identificador, setIdentificador] = useState('')
	const [tamanyo, setTamanyo] = useState('')
	const [idMotor, setIdMotor] = useState('')
	const [activo, setActivo] = useState(false)
	const [fechaInstalacion, setFechaInstalacion] = useState('')
	const [mac, setMac] = useState('')

	const [identificadorError, setIdentificadorError] = useState('')
	const [tamanyoError, setTamanyoError] = useState('')
	const [idMotorError, setIdMotorError] = useState('')
	const [macError, setMacError] = useState('')
	const [habitacionError, setHabitacionError] = useState('')
	const [tipoError, setTipoError] = useState(null)

	

	const [t] = useTranslation("global");

	const toastGenericErrorLogin = () => toast.error(t('app.error.login.generic'));


	useEffect(() => {
		obtenerListaHabitaciones();
//		props.loadCamas()
		obtenerListaTipoCama();

		setSelectedCama(props.selectedCama);

		if (props.selectedCama != null) {
			// Modo edicion

			setSelectedHabitacion(props.selectedCama.habitacion);
			setIdentificador(props.selectedCama.identificador);
			setTamanyo(props.selectedCama.tamanyo);
			setIdMotor(props.selectedCama.idMotor);
			setActivo(props.selectedCama.activo);
			setFechaInstalacion(props.selectedCama.fechaInstalacion);
			setMac(atob(props.selectedCama.mac));
			setSelectedTipoCama(props.selectedCama.tipoCama)

		}
	}, [props.selectedCama]);


	function handleLogin(e) {
		e.preventDefault()
		// Code to handle login goes here
		props.toggle()
	}

	const obtenerListaHabitaciones = async () => {
		await HabitacionService.getHabitaciones(props.establecimiento)
			.then(response => response.json())
			.then(data => setListaHabitaciones(data));
	}

	const obtenerListaTipoCama = async () => {
		await CamaService.getTiposCama()
			.then(response => response.json())
			.then(data => setListaTiposCama(data));
	}


	function validateForm(cama) {

		// Set initial error values to empty  
		setHabitacionError('')
		setIdentificadorError('')		
		setIdentificadorError('')
		setTamanyoError('')
		setTipoError(null)
		setMacError('')

		if (cama.habitacion === '') {
			setHabitacionError(t('app.error.campoObligatorio'))
			return;
		}
		
		if (cama.identificador === '') {
			setIdentificadorError(t('app.error.campoObligatorio'))
			return;
		}

		if (cama.tamanyo === '') {
			setTamanyoError(t('app.error.campoObligatorio'))
			return;
		}
		
		if (!checkTamanyoCama(cama.tamanyo)) {
			setTamanyoError(t('app.error.tamanyoCamaFormat'))
			return;
		}

		if (cama.tipoCama === null) {
			setTipoError(t('app.error.campoObligatorio'))
			return;
		}
		
		if (cama.mac !== '') {
			cama.mac = btoa(cama.mac);
		}

		if (cama.id != null) {
			updateCama(cama);
		} else {
			insertCama(cama);
		}
	}

	function checkTamanyoCama(tamanyo) {
		return Constants.tamanyoCamaRegex.test(tamanyo)
	}
	
	function checkMacCama(mac) {
		return Constants.macCamaRegex.test(mac)
	}


	const guardarCama = async () => {

		if (selectedCama != null) {
			editarCama(selectedCama);
		} else {
			crearCama();
		}

	}

	const crearCama = async () => {

		const cama = {
			habitacion: selectedHabitacion,
			identificador: identificador,
			tamanyo: tamanyo,
			idMotor: idMotor,
			activo: true,
			fechaInstalacion: fechaInstalacion,
			mac: mac,
			tipoCama: selectedTipoCama
		};
		validateForm(cama);
	}


	const editarCama = async (selectedCama) => {

		const cama = {
			id: selectedCama.id,
			habitacion: selectedHabitacion,
			identificador: identificador,
			tamanyo: tamanyo,
			idMotor: idMotor,
			activo: activo,
			fechaInstalacion: fechaInstalacion,
			mac: mac,
			tipoCama: selectedTipoCama
		};

		validateForm(cama);
	}


	const insertCama = async (cama) => {
		await CamaService.crearCama(cama)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
					props.limpiarFiltros();
					props.loadCamas();

				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const updateCama = async (cama) => {
		await CamaService.actualizarCama(cama)
			.then((response) => {
				if (response.status === 200) {

					// Close popup on insert success
					props.toggle();

					// Refresh table
					if (props.selectedHabitacion != null || props.filtroActivo != null || props.selectedTipoCama != null || props.filtroEdificio !== '' || props.filtroPlanta !== '') {
						props.loadCamasByParams(props.selectedHabitacion, props.filtroActivo, props.selectedTipoCama, props.filtroEdificio, props.filtroPlanta);
					} else {
						props.limpiarFiltros();
						props.loadCamas();
					}
				} else {
					toastGenericErrorLogin();
				}
			})
			.catch((err) => {
				toastGenericErrorLogin();
			});;
	}

	const cancelarCama = () => {

		// Close popup
		props.toggle();
	}


	const onChangeHabitacion = (ev) => {
		setSelectedHabitacion(ev.id)
	}

	const colorFiltros = {
	  menuList: styles => ({
	    ...styles,
	    background: '#FAE6F1',
	  }),
	  option: (styles, { isFocused, isSelected }) => ({
	    ...styles,
	    background: isSelected
	        ? '#91005F'
	        : '#FAE6F1',
	    zIndex: 1,
	    "&:hover": {
			background: 'rgba(145, 0, 95, 0.2)',
			color: '#000'
		},
	  }),
	  menu: base => ({
	    ...base,
	    zIndex: 100
	  }),
	}
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Habitaciones del PopUp
	const getOptionValueHabitacion = option => option.id;
	
	// Para mostrar el color de fondo de la opción elegida en la lista de Tipo camas
	const getOptionValueTipoCama = option => option.id;

	return (
		<div className="popup">
			<div className="popup-inner">
				<div className="popup-Header">
					{selectedCama != null ? <h1 className={"popup-Title"}>{t("app.cama.edicionCama")}</h1> : <h1 className={"popup-Title"}>{t("app.cama.nuevaCama")}</h1>}
					<button className="popup-btn-x" onClick={props.toggle}><MdClear /></button>
				</div>

				<div className="popup-Content">
					<form className="form-nuevaCama" onSubmit={handleLogin}>
						<div className="popup-div-inputs-popup">
						
							<div className={'inputAndSelectContainerPopup'}>
								<Select
									className="selectPopupStyle"
									placeholder={t("app.label.seleccionarHabitacion")}
									value={listaHabitaciones.find(e => e.id === selectedHabitacion)}
									onChange={onChangeHabitacion}
									options={listaHabitaciones}
									isSearchable={false}
									formatOptionLabel={habitacion => (
										<div>
											<span>{habitacion.numero}</span>
										</div>
									)}
									styles={colorFiltros}
									getOptionValue={getOptionValueHabitacion}
								/>
								<label className="errorLabel">{habitacionError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.cama.popup.identificador")} type="text" value={identificador} onChange={e => setIdentificador(e.target.value)} />
								<label className="errorLabel">{identificadorError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.cama.popup.tamanyo")} type="text" value={tamanyo} onChange={e => setTamanyo(e.target.value)} />
								<label className="errorLabel">{tamanyoError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<Select
									className="selectPopupStyle"
									placeholder={t("app.label.seleccionarTipoCama")}
									value={selectedTipoCama}
									onChange={setSelectedTipoCama}
									options={listaTiposCama}
									isSearchable={false}
									formatOptionLabel={tipo => (
										<div>
											<span>{tipo.nombre}</span>
										</div>
									)}
									styles={colorFiltros}
									getOptionValue={getOptionValueTipoCama}
								/>
								<label className="errorLabel">{tipoError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.cama.popup.idMotor")} type="text" value={idMotor} onChange={e => setIdMotor(e.target.value)} />
								<label className="errorLabel">{idMotorError}</label>
							</div>

							<div className={'inputAndSelectContainerPopup'}>
								<input placeholder={t("app.cama.popup.mac")} disabled={true} type="text" value={mac} onChange={e => setMac(e.target.value)} />
								<label className="errorLabel">{macError}</label>
							</div>


							{selectedCama != null ? (
								<div className={'checkboxContainerCama'}>
									<label>{t("app.popup.label.activo")}</label>
									<input type='checkbox' id='checkboxActivo' checked={activo} onChange={e => setActivo(e.target.checked)} />
								</div>
							) : null}

						</div>

						<div className="popup-div-buttons">
							<button type="button" className="btn-general-colorPink" onClick={cancelarCama}>{t("app.label.cancelar")}</button>
							<button type="button" className="btn-general" onClick={guardarCama}>{t("app.label.guardar")}</button>
							<Toaster />
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default PopUpCama